// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rn-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 3px;
  min-height: 20px;
}
.rn-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  flex-shrink: 0;
}
.rn-yellow { background: #dcaa00; color: #1e1e1e; }
.rn-red    { background: var(--red); color: #fff; }
.rn-add {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  color: var(--text-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.rn-add:hover { color: var(--text-primary); background: var(--bg-hover); }
.rn-form {
  display: flex;
  align-items: center;
  gap: 3px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 3px;
  padding: 2px 4px;
  position: absolute;
  z-index: 100;
  margin-top: 2px;
  box-shadow: 0 4px 12px rgba(0,0,0,.4);
  white-space: nowrap;
}
.rn-input {
  width: 140px !important;
  font-size: 12px;
  padding: 1px 4px !important;
  background: var(--bg-input) !important;
  border: 1px solid var(--border) !important;
  border-radius: 2px;
  color: var(--text-primary);
  outline: none;
}
.rn-ok, .rn-cancel {
  font-size: 11px;
  color: var(--text-muted);
  padding: 0 2px;
}
.rn-ok:hover     { color: var(--green); }
.rn-cancel:hover { color: var(--red); }

/* Tap/click popover with the notice texts */
.rn-popover {
  position: fixed;
  z-index: 300;
  max-width: min(320px, calc(100vw - 16px));
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,.4);
  font-size: 12px;
  color: var(--text-primary);
  white-space: normal;
  overflow-wrap: anywhere;
}
.rn-popover-row { display: flex; align-items: flex-start; gap: 6px; }
`, "",{"version":3,"sources":["webpack://./src/components/common/RowNotices.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,aAAa,sBAAsB,EAAE,WAAW,EAAE;AAClD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA,gBAAgB,0BAA0B,EAAE,2BAA2B,EAAE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,sCAAsC;EACtC,0CAA0C;EAC1C,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;AACA,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,iBAAiB,EAAE;;AAEtC,4CAA4C;AAC5C;EACE,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;AACA,kBAAkB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE","sourcesContent":[".rn-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 3px;\n  min-height: 20px;\n}\n.rn-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 900;\n  line-height: 1;\n  flex-shrink: 0;\n}\n.rn-yellow { background: #dcaa00; color: #1e1e1e; }\n.rn-red    { background: var(--red); color: #fff; }\n.rn-add {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  color: var(--text-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n.rn-add:hover { color: var(--text-primary); background: var(--bg-hover); }\n.rn-form {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  padding: 2px 4px;\n  position: absolute;\n  z-index: 100;\n  margin-top: 2px;\n  box-shadow: 0 4px 12px rgba(0,0,0,.4);\n  white-space: nowrap;\n}\n.rn-input {\n  width: 140px !important;\n  font-size: 12px;\n  padding: 1px 4px !important;\n  background: var(--bg-input) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 2px;\n  color: var(--text-primary);\n  outline: none;\n}\n.rn-ok, .rn-cancel {\n  font-size: 11px;\n  color: var(--text-muted);\n  padding: 0 2px;\n}\n.rn-ok:hover     { color: var(--green); }\n.rn-cancel:hover { color: var(--red); }\n\n/* Tap/click popover with the notice texts */\n.rn-popover {\n  position: fixed;\n  z-index: 300;\n  max-width: min(320px, calc(100vw - 16px));\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 10px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0,0,0,.4);\n  font-size: 12px;\n  color: var(--text-primary);\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n.rn-popover-row { display: flex; align-items: flex-start; gap: 6px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
